import React from 'react';
import ManagementAction from './ManagementAction';
import ArticleSync from './ArticleSync';
import FreshdeskTagging from './FreshdeskTagging';
import { gridStyle } from './styles';

const Management = () => (
    <div style={gridStyle}>
        <ArticleSync />

        <FreshdeskTagging />

        <ManagementAction
            title="Kundsynk från Fortnox"
            description="Hämtar kunder från Fortnox och skapar eller uppdaterar motsvarande organisationer i Litium."
            endpoint="customer-sync"
            buttonLabel="Starta kundsynk från Fortnox"
        />

        <ManagementAction
            title="Prissynk från Fortnox"
            description="Hämtar priserna för en prislista i Fortnox och uppdaterar priserna i Litium. Ange prislistans kod i Fortnox."
            endpoint="price-sync"
            buttonLabel="Starta prissynk från Fortnox"
            fields={[{ name: 'priceList', placeholder: 'Prislista', required: true }]}
        />

        <ManagementAction
            title="Lagersynk från Fortnox"
            description="Hämtar tillgängligt lagersaldo för alla artiklar från Fortnox och uppdaterar lagret i Litium. Artiklar som saknas i Fortnox sätts till slut i lager och paketartiklar räknas om."
            endpoint="stock-balance-sync"
            buttonLabel="Starta lagersynk från Fortnox"
        />

        <ManagementAction
            title="Bevakning av åter i lager"
            description="Kör jobbet som mejlar B2B-användare när en bevakad artikel är tillbaka i lager. Samma jobb som körs enligt schema."
            endpoint="in-stock-monitor"
            buttonLabel="Kör bevakning av åter i lager"
        />

        <ManagementAction
            title="Pushnotis"
            description="Skickar en pushnotis med rubriken Info till alla appanvändare som har registrerat sin enhet."
            endpoint="push"
            buttonLabel="Skicka pushnotis"
            fields={[{ name: 'message', placeholder: 'Pushmeddelande', required: true }]}
        />

        <ManagementAction
            title="Skapa order i Fortnox"
            description="Skapar en Litium-order som en order i Fortnox, på kundnumret som hör till ordern. Misslyckas om ordern redan finns i Fortnox."
            endpoint="create-order-in-fortnox"
            buttonLabel="Skapa order i Fortnox"
            fields={[{ name: 'orderId', placeholder: 'Litium ordernummer (LSXXXXXX)', required: true }]}
        />

        <ManagementAction
            title="Synkronisera order från Fortnox"
            description="Hämtar en order från Fortnox på nytt och uppdaterar status på tillhörande Litium-order. Är ordern fakturerad skapas en leverans och ordern slutförs."
            endpoint="sync-order-from-fortnox"
            buttonLabel="Synkronisera order från Fortnox"
            fields={[{ name: 'orderId', placeholder: 'Fortnox ordernummer (12345)', required: true }]}
        />

        <ManagementAction
            title="Radera leverans i Litium"
            description="Raderar en leverans i Litium. Används för att rensa bort felaktiga leveranser. Går inte att ångra."
            endpoint="delete-shipment"
            buttonLabel="Radera leverans i Litium"
            fields={[{ name: 'shipmentId', placeholder: 'Litium leverans-id', required: true }]}
            confirmMessage="Vill du radera leveransen i Litium?"
        />

        <ManagementAction
            title="Slutför order i Litium"
            description="Flyttar en Litium-order steg för steg via orderstatusarna tills den är Slutförd. Ordrar som redan är slutförda påverkas inte."
            endpoint="complete-order"
            buttonLabel="Slutför order i Litium"
            fields={[{ name: 'orderId', placeholder: 'Litium ordernummer (LSXXXXXX)', required: true }]}
        />

        <ManagementAction
            title="Flytta artiklar till lagerplats"
            description="Flyttar befintligt saldo till den nya lagerplatsen i Fortnox och sätter den som artikelns standardlagerplats. Ange en enstaka flytt, flera rader (artikelnr;lagerplats, ett par per rad), eller båda."
            endpoint="stock-transfer"
            buttonLabel="Flytta artiklar till lagerplats"
            wide
            fields={[
                { name: 'articleNumber', label: 'Enstaka flytt', placeholder: 'Artikelnummer', half: true },
                { name: 'newStockLocationCode', label: 'Ny lagerplats', placeholder: 'Lagerplats', half: true },
                { name: 'bulkTransfers', label: 'Flytta flera (en per rad)', type: 'textarea', rows: 8, placeholder: '12345;02AB\n67890;02AC\n11111;07DG' },
            ]}
        />

        <ManagementAction
            title="Lägg till lagerplatser i Fortnox"
            description="Skapar nya lagerplatser på lagerstället i Fortnox. Ange en lagerplatskod per rad, t.ex. 02AB. Koder som redan finns hoppas över."
            endpoint="add-stock-locations"
            buttonLabel="Lägg till lagerplatser"
            wide
            fields={[{ name: 'locations', label: 'Lagerplatser (en per rad)', type: 'textarea', rows: 8, placeholder: '02AB\n02AC\n07DG', required: true }]}
        />
    </div>
);

export default Management;
